import { render } from "./ForecastResultsHeader.vue?vue&type=template&id=13fa0436"
import script from "./ForecastResultsHeader.vue?vue&type=script&lang=js"
export * from "./ForecastResultsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniomarrazzo/Janus - Pasar/janus-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__